<template>
  <div>
    <list-header
      :title="`My Activities (Recent ${filteredPurchaseHistory.length})`"
    />
    <pull-to-refresh :refreshFunction="getPurchaseHistory">
      <div v-if="filteredPurchaseHistory?.length !== 0">
        <history-item-list
          v-for="purchaseHistory in filteredPurchaseHistory"
          :key="purchaseHistory.id"
          :name="purchaseHistory.items[0]?.product?.name"
          :date="formatDateTime(purchaseHistory.date)"
          :price="formatPrice(purchaseHistory.roundedTotal)"
          :hidePrice="hidePriceConditional(purchaseHistory)"
          :paymentStatus="getPaymentStatusName(purchaseHistory.paymentStatus)"
          :branchName="getBranchNameById(purchaseHistory.branch)"
        />
      </div>
      <div v-else>
        <item-not-found message="No activity found." />
      </div>
    </pull-to-refresh>
  </div>
</template>

<script>
import ListHeader from "@/components/ListHeader.vue";
import PullToRefresh from "@/components/PullToRefresh";
import { mapMutations } from "vuex";
import { dateTimeFormat } from "@/common/constant/DateTimeFormat";
import ItemNotFound from "@/components/ItemNotFound.vue";
import { mapGetters, mapActions } from "vuex";

import {
  convertDateTimeToTimezone,
  getTodaysDate,
} from "@/common/helpers/DateTimeHelper";
import {
  convertToTime,
  convertDateFormat,
} from "@/common/helpers/DateTimeHelper";
import { formatPrice } from "@/common/helpers/PriceHelper.js";
import { getBranchNameById } from "@/common/helpers/BaseHelper";
import { paymentStatus } from "@/common/constant/PaymentStatus";

import HistoryItemList from "@/components/HistoryItemList.vue";

export default {
  name: "PurchaseHistory",
  components: { ListHeader, PullToRefresh, HistoryItemList, ItemNotFound },
  computed: {
    filteredPurchaseHistory() {
      if (this.purchaseHistories) {
        const todaysDate = getTodaysDate();

        // Filter purchase record <= todays
        return this.purchaseHistories.filter((data) => {
          const convertedTime = convertDateTimeToTimezone({
            dateTime: data.date,
            outputFormat: dateTimeFormat.API_DATE_FORMAT,
          });

          return convertedTime <= todaysDate ? true : false;
        });
      }

      return [];
    },
    ...mapGetters(
      [
        "init",
        "purchaseHistories",
      ]
    ),
  },
  methods: {
    async fetchPurchaseHistory() {
      if (this.purchaseHistories !== null) {
        return;
      }
      this.showLoading(true);
      await this.getPurchaseHistory();
      this.showLoading(false);
    },
    getPaymentStatusName(status) {
      return paymentStatus[status];
    },
    formatPrice,
    formatDateTime(dateTime) {
      return `${convertDateFormat(dateTime)} ${convertToTime(dateTime)}`;
    },
    hidePriceConditional(purchaseHistory) {
      // only hide price if all of the following condition met
      //  1. if wess-legacy > consumer web app > hide service price is Yes
      //  2. booking is book via CWA and not involve payment gateway
      return this.init.hideServicePrice > 0 &&
        (
          purchaseHistory.onlineBookingPayment?.ticketId === undefined ||
          purchaseHistory.onlineBookingPayment?.ticketId === null
        );
    },
    getBranchNameById,
    ...mapActions(["getPurchaseHistory"]),
    ...mapMutations(["showLoading"]),
  },
  created() {
    this.fetchPurchaseHistory();
  },
};
</script>
